import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { motion } from "framer-motion";

export default function BlogListPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/blog")
      .then((r) => setPosts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-list-page" className="min-h-screen bg-[#ffffff] text-[#0a0a0a]">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="overline mb-4">Producer stories</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#0a0a0a] max-w-3xl">
            How agents are <em className="not-italic text-[#121275]">actually</em> winning
            in 2026.
          </h1>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {loading
              ? Array.from({ length: 3 }).map((_, i) => (
                  <div key={i} className="bg-[#f7f7f7] border border-black/10 h-96 animate-pulse" />
                ))
              : posts.map((p, i) => (
                  <motion.div
                    key={p.id}
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: i * 0.06 }}
                  >
                    <Link
                      to={`/blog/${p.slug}`}
                      data-testid={`blog-list-card-${i}`}
                      className="block group bg-[#f7f7f7] border border-black/10 hover:border-[#121275]/40 transition-colors"
                    >
                      {p.cover_image && (
                        <div className="aspect-[4/3] bg-cover bg-center" style={{ backgroundImage: `url(${p.cover_image})` }} />
                      )}
                      <div className="p-6">
                        {p.agent_revenue && (
                          <div className="numeric text-xs text-[#121275] uppercase tracking-widest">
                            {p.agent_revenue}
                          </div>
                        )}
                        <h3 className="font-display text-lg text-[#0a0a0a] mt-3 font-light leading-tight group-hover:text-[#121275] transition-colors">
                          {p.title}
                        </h3>
                        <p className="text-black/55 text-sm mt-3 line-clamp-3">{p.excerpt}</p>
                        <div className="numeric text-[10px] text-black/30 uppercase tracking-widest mt-6">
                          {new Date(p.created_at).toLocaleDateString("en-US", {
                            month: "short", day: "numeric", year: "numeric",
                          })}
                        </div>
                      </div>
                    </Link>
                  </motion.div>
                ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
